import React, { useState, useEffect } from "react";
import { db } from "../utils/firebase";
import { onValue, ref, remove } from "firebase/database";
import MainHeader from "../components/MainHeader";
import { FaTrash } from "react-icons/fa6";

const HistoryPage = () => {
  const [xrayData, setXrayData] = useState([]);
  const username = localStorage.getItem("username");

  useEffect(() => {
    const xdataRef = ref(db, "xray_data");
    onValue(xdataRef, (snapshot) => {
      const dataVal = snapshot.val();
      if (dataVal) {
        const filteredData = Object.entries(dataVal).filter(
          ([key, data]) => data.name === username
        );
        setXrayData(filteredData.map(([key, data]) => ({ key, ...data })));
      }
    });
  }, [username]);

  const deleteData = (key) => {
    const dataRef = ref(db, `xray_data/${key}`);
    remove(dataRef)
      .then(() => {
        // Remove the deleted item from the state
        setXrayData((prevData) => prevData.filter((data) => data.key !== key));
      })
      .catch((error) => {
        console.error("Error removing document: ", error);
      });
  };

  return (
    <div>
      <MainHeader />
      <div>
        <h2 className="text-center font-semibold my-8">X-Ray Data for <span className="italic">{username}</span></h2>
        <div className="flex flex-col">
          <div className="-m-1.5 overflow-x-auto mx-32">
            <div className="p-1.5 min-w-full inline-block align-middle">
              <div className="overflow-hidden">
                <table className="min-w-full mt-10 divide-y divide-gray-200 dark:divide-gray-700">
                  <thead>
                    <tr className="">
                      <th
                        scope="col"
                        className="px-6 py-3 text-start text-lg font-medium text-gray-500 uppercase"
                      >
                        Date
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-start text-lg font-medium text-gray-500 uppercase"
                      >
                        Age
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-start text-lg font-semibold text-gray-500 uppercase"
                      >
                        Gender
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-start text-lg font-semibold text-gray-500 uppercase"
                      >
                        Image
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-start text-lg font-semibold text-gray-500 uppercase"
                      >
                        Disease
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-end text-lg font-semibold text-gray-500 uppercase"
                      >
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
                    {xrayData.map((data) => (
                      <tr key={data.key} className="hover:bg-emerald-100 font-semibold">
                        <td className="px-6 py-4 whitespace-nowrap text-md font-medium text-gray-800">
                          {data.date}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-md text-gray-800">
                          {data.age}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-md text-gray-800">
                          {data.gender}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-md text-gray-800">
                          <img src={data.image} alt="" className="w-[80px] h-[100px]" />
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-md text-gray-800">
                          {data.disease}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-end text-md font-medium">
                          <button onClick={() => deleteData(data.key)} className="text-center"><FaTrash className="w-5 h-5 text-red-600" /></button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HistoryPage;
